module.exports = __webpack_public_path__ + "img/cropped-icon.314e3cdb.png";